import React, { ReactElement } from 'react';
import { FormHorizontal } from '~/components/form/layout';
import ZodFieldCheckbox from '~/components/zod/ZodFieldCheckbox';
import FormGroup from '~/components/form/FormGroup';
import ZodFieldCards from '~/components/zod/ZodFieldCards';
import { TenantPerformableFormProps } from '~/tenants/common/form';
import { McmOrderContext } from '~/tenants/mcm/model/McmOrder';
import McmMatterportJob from '~/tenants/mcm/performable/matterport/McmMatterportJob';

export default function McmMatterportForm(props: TenantPerformableFormProps<McmOrderContext>): ReactElement {
  return (
    <FormGroup>
      <FormHorizontal name="exterior" label="Capture Area">
        <ZodFieldCards
          name="exterior"
          options={[
            {
              title: 'Interior Only',
              value: 'false',
              cost: McmMatterportJob.calculate(props.context, false),
            },
            {
              title: 'Interior + Exterior',
              value: 'true',
              cost: McmMatterportJob.calculate(props.context, true),
            },
          ]}
        />
      </FormHorizontal>
      <FormHorizontal name="floorplan" label="2D Floorplan Export">
        <ZodFieldCheckbox name="floorplan" />
      </FormHorizontal>
    </FormGroup>
  );
}
